import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer className="bg-gray-900 text-gray-300 border-t-4 border-accent">
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Firm Info */}
        <div>
          <img
            src="/privateImages/brulandlogoFooter-white.webp"
            alt="Advokatfirmaet Bruland"
            className="h-16 mb-4"
          />
          <p className="text-gray-400 leading-relaxed">
            Vi er et lite og spesialisert advokatfirma som tilbyr målrettet juridisk bistand
            med individuell oppfølging.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-white font-semibold text-lg mb-4">Hurtiglenker</h3>
          <ul className="space-y-2">
            <li>
              <Link to="/" className="hover:text-accent transition-colors">
                Hjem
              </Link>
            </li>
            <li>
              <Link to="/om-oss" className="hover:text-accent transition-colors">
                Om oss
              </Link>
            </li>
            <li>
              <Link to="/arv-og-testament" className="hover:text-accent transition-colors">
                Arv og testament
              </Link>
            </li>
            <li>
              <Link to="/arbeidsrett" className="hover:text-accent transition-colors">
                Arbeidsrett
              </Link>
            </li>
            <li>
              <Link to="/fast-eiendom" className="hover:text-accent transition-colors">
                Fast eiendom
              </Link>
            </li>
            <li>
              <Link to="/kontakt" className="hover:text-accent transition-colors">
                Kontakt
              </Link>
            </li>
            <li>
              <Link to="/oppdragsvilkar" className="hover:text-accent transition-colors">
                Oppdragsvilkår
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-white font-semibold text-lg mb-4">Kontakt</h3>
          <ul className="space-y-2 text-gray-400">
            <li>Drammensveien 82c</li>
            <li>0271 Oslo</li>
            <li className="mt-4">
              <a href="tel:+4722535322" className="hover:text-accent transition-colors">
                (+47) 225 35 322
              </a>
            </li>
            <li>
              <a href="mailto:advokat@bruland.no" className="hover:text-accent transition-colors">
                advokat@bruland.no
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 pt-8 mt-12 text-sm text-gray-500 text-center">
        <p>© 2025 Advokatfirmaet Bruland. Alle rettigheter reservert.</p>
      </div>
    </div>
  </footer>
);

export default Footer;

